// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","checked":"Checkbox_checked__XxrrH","disabled":"Checkbox_disabled__h5VEk","selectAll":"Checkbox_selectAll__YedRR"};